import {
  Blue200,
  Brand100,
  Brand200,
  Brand400,
  Gray100,
  Gray25,
  Green100,
  Green200,
  Green600,
  Orange200,
  Purple200,
  Yellow200,
} from "../../../styles/color";

// 200
export const divideMarkColorByRoom = (room = "") => {
  switch (room) {
    case "회의실 본사 2층":
      return Brand200;
    case "회의실 본사 3층":
      return Orange200;
    case "회의실 본사 4층":
      return Yellow200;
    case "회의실 본사 5층":
      return Green200;
    case "회의실 본사 7층":
      return Blue200;
    case "회의실 본사 8층":
      return Purple200;
    case "회의실 본사 9층":
      return Purple200;
    default:
      return "#FFFFFF";
  }
};

// 25
export const divideItemBgColorByRoom = (
  isSelected = false,
  isAvailable = true
) => {
  if (isSelected && isAvailable) return Green100;
  if (isSelected && !isAvailable) return Brand100;

  return Gray25;
};

export const divideItemBorderColorByRoom = (
  isSelected = false,
  isAvailable = true
) => {
  if (!isSelected && isAvailable) return Green200;
  else if (!isSelected && !isAvailable) return Brand200;

  if (isSelected && isAvailable) return Green600;
  else if (isSelected && !isAvailable) return Brand400;

  // if (isSelected) return Blue700;
};
